import React from "react";
import { FreeMode, Navigation, Thumbs } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

export function GalleryPopup({ Activities, ...props }) {
  // console.log('Activities', Activities)

  const sortedActivities = React.useMemo(() => {
    if (!Activities) return [];
    return [...Activities].sort((a, b) => {
      if (a?.date && b?.date) {
        return new Date(b.date) - new Date(a.date);
      }
      if (a?.id !== undefined && b?.id !== undefined) {
        return b.id - a.id;
      }
      if (a?._id && b?._id) {
        return String(b._id).localeCompare(String(a._id));
      }
      return 0;
    });
  }, [Activities]);

  const initialSlideIndex = React.useMemo(() => {
    if (!props.activeItem || props.activeItem === true) return 0;
    const index = sortedActivities.findIndex((item) => {
      if (item?.id !== undefined && props.activeItem?.id !== undefined && item.id === props.activeItem.id) return true;
      if (item?._id && props.activeItem?._id && item._id === props.activeItem._id) return true;
      if (item?.Avatar && props.activeItem?.Avatar && item.Avatar === props.activeItem.Avatar) return true;
      if (item?.media?.[0]?.url && props.activeItem?.media?.[0]?.url && item.media[0].url === props.activeItem.media[0].url) return true;
      if (item?.url && props.activeItem?.url && item.url === props.activeItem.url) return true;
      return false;
    });
    return index !== -1 ? index : 0;
  }, [sortedActivities, props.activeItem]);

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className="gallery-popup sticky left-0 right-0  top-32 mx-0 h-[84vh] w-full bg-white bg-opacity-0 lg:mx-auto lg:w-[70%]"
    >
      <Swiper
        style={{
          "--swiper-navigation-color": "#fff",
          "--swiper-pagination-color": "#fff",
        }}
        spaceBetween={50}
        navigation={true}
        thumbs={{
          swiper:
            props.thumbsSwiper && !props.thumbsSwiper.destroyed
              ? props.thumbsSwiper
              : null,
        }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper2"
        initialSlide={initialSlideIndex}
      >
        {sortedActivities?.map((item) => (
          <SwiperSlide key={item?.id || item?._id}>
            <div className="" key={item?.id || item?._id}>
              <div
                onClick={() => props.setIsVisible(false)}
                className="flex border h-[500px] w-[500px]"
              >
                <img
                  src={item?.media?.[0]?.url || item?.Avatar || item?.url}
                  alt=""
                  className="h-20 w-20 md:h-96 md:w-96"
                  // layout="fill"
                />
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <Swiper
        onSwiper={props.setThumbsSwiper}
        spaceBetween={20}
        slidesPerView={3}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        initialSlide={initialSlideIndex}
        // className="mySwiper"
        breakpoints={{
          640: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 40,
          },
          1024: {
            slidesPerView: 6,
            spaceBetween: 50,
          },
        }}
      >
        {sortedActivities?.map((item) => (
          <SwiperSlide
            key={item?.id || item?._id}
            style={{
              cursor: "pointer",
            }}
          >
            {/* <div className="">
              <div className="mx-5"> */}
            <img
              src={item?.media?.[0]?.url || item?.Avatar}
              alt=""
              height="400px"
              width="400px"
              // layout="fill"
              className="p-3 mb-5"
            />
            {/* </div>
            </div> */}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
